// extracted by mini-css-extract-plugin
export var formContainer = "_ej-0";
export var message = "_ej-1";